<div class="row" *ngIf="showAddBar">
 
  <div class="col-lg-12">
    <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b cursor-pointer"
      (click)="createTask()"
      role="alert"
      style="padding: 10px; margin-bottom: 6px"
    >
      <div class="alert-icon" style="padding-right: 5px">
        <span class="svg-icon svg-icon-success svg-icon-l"
          ><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo1/dist/../src/media/svg/icons/Navigation/Plus.svg--><svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect fill="#000000" x="4" y="11" width="16" height="2" rx="1" />
              <rect
                fill="#000000"
                opacity="0.3"
                transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) "
                x="4"
                y="11"
                width="16"
                height="2"
                rx="1"
              />
            </g></svg
          ><!--end::Svg Icon--></span
        >
      </div>
      <div class="alert-text">Add Task</div>
    </div>
  </div>
</div>

<div class="card card-custom" [ngStyle]="getStyleComponent()" style="height: 95%">
  <div class="card-header">
    <div class="card-toolbar w-100 w-lg-auto">
      <ul class="nav nav-tabs nav-bold nav-tabs-line">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-toggle="tab"
            (click)="resetPagination('OPEN'); loadTasks(false, false)"
          >
            <span class="nav-text">Open Tasks ({{ openTaskLength }})</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-toggle="tab"
            (click)="resetPagination('COMPLETED'); loadTasks(true, false)"
          >
            <span class="nav-text">Completed ({{ completedTaskLength }})</span>
          </a>
        </li>
        <li class="nav-item" *ngIf="!patientId || !doctorId">
          <a
            class="nav-link"
            data-toggle="tab"
            (click)="resetPagination('CANCELED'); loadTasks(false, true)"
          >
            <span class="nav-text">Cancelled ({{ cancelledTaskLength }})</span>
          </a>
        </li>
      </ul>
      <div style="margin-bottom: -20px" class="ml-auto ml-lg-5" *ngIf="!this.inputTasks">
        <mat-form-field class="mat-form-field-fluid" appearance="outline">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput placeholder="{{ 'TABLE.SEARCH' | translate }}" [formControl]="search" />
          <button
            *ngIf="this.search.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="
              this.search.setValue(''); paginator.pageIndex = 0; loadTasks(isCompleted, isCanceled)
            "
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div class="card-toolbar w-100 w-lg-auto">
      <div
        *ngIf="showGroupTeam"
        [hidden]="groupedByTeam || groupedByTemplate || groupedByTag || fromPatient"
      >
        <div
          class="dropdown dropdown-inline"
          data-toggle="tooltip"
          title=""
          data-placement="left"
          data-original-title="Group by"
          aria-describedby="tooltip546921"
        >
          <a
            href="#"
            class="btn mr-2 btn-hover-secondary mat-button default-button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Group View
          </a>
          <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right" style="">
            <!--begin::Navigation-->
            <ul class="navi navi-hover">
              <li class="navi-item">
                <a
                  [routerLink]="['/task/groups']"
                  [queryParams]="getQueryParams('team')"
                  class="navi-link"
                >
                  <span class="navi-text">Team</span>
                </a>
              </li>
              <li class="navi-item">
                <a
                  [routerLink]="['/task/groups']"
                  [queryParams]="getQueryParams('template')"
                  class="navi-link"
                >
                  <span class="navi-text">Task Template</span>
                </a>
              </li>
              <li class="navi-item">
                <a
                  [routerLink]="['/task/groups']"
                  [queryParams]="getQueryParams('tag')"
                  class="navi-link"
                >
                  <span class="navi-text">Tag</span>
                </a>
              </li>
              <li class="navi-item">
                <a
                  [routerLink]="['/task/groups']"
                  [queryParams]="getQueryParams('patient')"
                  class="navi-link"
                >
                  <span class="navi-text">Patient</span>
                </a>
              </li>
            </ul>
            <!--end::Navigation-->
          </div>
        </div>
      </div>
      <div>
        <button
          class="mr-2"
          [ngClass]="isFollowing ? 'filter-button-active' : 'default-button'"
          mat-button
          color="{{ isFollowing ? 'primary' : '' }}"
          (click)="fetchFollowingTasks()"
        >
          Following
        </button>
      </div>
      <div>
        <button
          class="mr-2"
          [ngClass]="isMyTasks ? 'filter-button-active' : 'default-button'"
          mat-button
          color="{{ isMyTasks ? 'primary' : '' }}"
          #myTaskBtn
          (click)="fetchMyTasks()"
        >
          My Tasks
        </button>
      </div>
      <div>
        <button
          class="mr-2"
          [ngClass]="isNotAssigned ? 'filter-button-active' : 'default-button'"
          mat-button
          color="{{ isNotAssigned ? 'primary' : '' }}"
          (click)="fetchNotAssignedTasks()"
        >
          Not Assigned
        </button>
      </div>
      <kt-task-filter-button
        *ngIf="!fromGroupBy"
        [isHidden]="{ hidden: !!inputTasks }"
        [groupedByTeam]="groupedByTeam"
        [groupedByTemplate]="groupedByTemplate"
        [groupedByTag]="groupedByTag"
        [isCompleted]="isCompleted"
        [isCanceled]="isCanceled"
        [fromPatient]="fromPatient"
        [fromDoctor]="fromDoctor"
        class="ml-auto ml-lg-5"
      >
      </kt-task-filter-button>
      <div class="dropdown dropdown-inline">
        <a
          class="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="ki ki-bold-more-ver"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right" style="">
          <!--begin::Navigation-->
          <ul class="navi navi-hover">
            <li class="navi-header pb-1">
              <span class="text-primary text-uppercase font-weight-bold font-size-sm"
                >Sort by: {{ sortTask }}</span
              >
            </li>
            <li class="navi-item" *ngIf="!sortSelected">
              <a
                (click)="sortTask = 'priority'; sortSelected = true; $event.stopPropagation()"
                class="navi-link"
              >
                <span class="navi-text">Priority</span>
              </a>
            </li>
            <li class="navi-item" *ngIf="!sortSelected">
              <a
                (click)="sortTask = 'created'; sortSelected = true; $event.stopPropagation()"
                class="navi-link"
              >
                <span class="navi-text">Date created</span>
              </a>
            </li>
            <li class="navi-item" *ngIf="!sortSelected">
              <a
                (click)="sortTask = 'dueDate'; sortSelected = true; $event.stopPropagation()"
                class="navi-link"
              >
                <span class="navi-text">Date due</span>
              </a>
            </li>
            <li class="navi-item" *ngIf="sortSelected">
              <a (click)="sortTasks(sortTask, 'asc')" class="navi-link">
                <span class="navi-text">Ascending</span>
              </a>
            </li>
            <li class="navi-item" *ngIf="sortSelected">
              <a (click)="sortTasks(sortTask, 'desc')" class="navi-link">
                <span class="navi-text">Descending</span>
              </a>
            </li>
          </ul>
          <!--end::Navigation-->
        </div>
      </div>
    </div>
  </div>
  <div style="overflow-x: auto; height: 100%; width: 100%; z-index: 0">
    <div
      class="tab-pane fade show active"
      id="kt_tab_pane_1_4"
      role="tabpanel"
      aria-labelledby="kt_tab_pane_1_4"
      style="min-width: 1000px; height: 100%"
    >
      <div class="task-header p-4" style="background-color: #e2e2e26b">
        <div class="header-item col-4" style="text-align: center; padding-right: 100px">Title</div>
        <div class="header-item col-4" style="padding-left: 100px">entities</div>
        <div class="header-item col-4" style="display: flex; justify-content: inherit">
          <div class="d-none d-lg-block" style="margin-right: 192px !important">status</div>
          <div style="width: 120px !important">assignee</div>
        </div>
      </div>
      <div
        class="mat-table-wrapper"
        style="padding: 5px; overflow-x: scroll; min-width: 1200px; height: 100%"
      >
        <mat-accordion *ngIf="!loading" class="example-headers-align">
          <mat-expansion-panel *ngFor="let task of taskList" [disabled]="task.lock" hideToggle>
            <mat-expansion-panel-header class="header" style="padding: 0; margin-bottom: 3px">
              <div style="display: flex">
                <div
                  class="border-color-{{ task.priority }} "
                  style="width: 5px"
                  [matTooltip]="'Priority: ' + (task.priority | titlecase)"
                ></div>
                <mat-panel-title class="border-grid-right">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <ng-template ngxPermissionsOnly="canEditTask">
                      <a
                        *ngIf="!isCanceled"
                        class="btn btn-icon number-of-days"
                        [matTooltip]="
                          (isCompleted ? 'Completed in ' : 'Created Before ') +
                          numberOfDaysCreated(task) +
                          ' Days'
                        "
                      >
                        {{ numberOfDaysCreated(task) }}
                      </a>
                    </ng-template>

                    <div class="ml-4 d-flex flex-column flex-grow-1 font-weight-bold">
                      <a
                        (click)="updateTask(task); $event.stopPropagation()"
                        [matTooltip]="task.title || 'No Title'"
                        class="text-dark text-hover-primary font-size-lg overflow-title"
                      >
                        {{ task.title || 'No Title' }}
                      </a>
                      <span class="font-size-sm text-muted">{{ task.current_step_title }}</span>
                      <span
                        *ngIf="task.completed_by && task.progress === 'DONE'"
                        class="text-primary font-size-sm"
                        >Completed by {{ task.completed_by }} on
                        {{ task.completed_at | date : 'MM/dd/yy' }}</span
                      >
                      <div
                        *ngIf="
                          !task.completed_by &&
                          task.progress !== 'DONE' &&
                          task.task_template &&
                          !inputTasks
                        "
                        class="font-size-sm"
                      >
                        <span>Team: </span
                        ><span class="font-size-sm text-muted">{{
                          task.task_template.category_name
                        }}</span>
                      </div>
                    </div>
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                  <table style="height: 100%">
                    <tr>
                      <td style="width: 380px">
                        <div *ngIf="task.task_entities.length > 0">
                          <div
                            class="gl-block"
                            *ngIf="mapArray(task.task_entities, 'PATIENT').length !== 0"
                          >
                            <span>
                              <span class="text-weight-bold entity-tag min-width-50"
                                >Patient:
                              </span>
                              <span
                                class="pr-1 pl-1 text-success text-hover-warning cursor entity-name"
                                (click)="navigateEntity('PATIENT', ent); $event.stopPropagation()"
                                *ngFor="let ent of task.task_entities; let i = index"
                                [hidden]="!mapObe(ent, 'PATIENT')"
                              >
                                <!--                      [class.border-right]="i !== patients.length-1"-->
                                {{ mapObe(ent, 'PATIENT') | getEntityName }}
                              </span>
                            </span>
                          </div>

                          <div *ngIf="mapArray(task.task_entities, 'DOCTOR').length !== 0">
                            <span>
                              <span class="text-weight-bold entity-tag min-width-50">Doctor: </span>
                              <span
                                class="pr-1 pl-1 text-success text-hover-warning cursor entity-name"
                                (click)="navigateEntity('DOCTOR', ent); $event.stopPropagation()"
                                *ngFor="let ent of task.task_entities; let i = index"
                                [hidden]="!mapObe(ent, 'DOCTOR')"
                              >
                                <!--                      [class.border-right]="i !== patients.length-1"-->
                                {{ mapObe(ent, 'DOCTOR') | getEntityName }}
                              </span>
                            </span>
                          </div>
                          <div *ngIf="mapArray(task.task_entities, 'FACILITY').length !== 0">
                            <span>
                              <span class="text-weight-bold entity-tag min-width-50"
                                >Facility:
                              </span>
                              <span
                                class="pr-1 pl-1 text-success text-hover-warning cursor entity-name"
                                (click)="navigateEntity('FACILITY', ent); $event.stopPropagation()"
                                *ngFor="let ent of task.task_entities; let i = index"
                                [hidden]="!mapObe(ent, 'FACILITY')"
                              >
                                <!--                      [class.border-right]="i !== patients.length-1"-->
                                {{ mapObe(ent, 'FACILITY') | getEntityName }}
                              </span>
                            </span>
                          </div>
                          <div *ngIf="mapArray(task.task_entities, 'CLIENT').length !== 0">
                            <span>
                              <span class="text-weight-bold entity-tag min-width-50">Client: </span>
                              <span
                                class="pr-1 pl-1 text-success text-hover-warning cursor entity-name"
                                (click)="navigateEntity('CLIENT', ent); $event.stopPropagation()"
                                *ngFor="let ent of task.task_entities; let i = index"
                                [hidden]="!mapObe(ent, 'CLIENT')"
                              >
                                <!--                      [class.border-right]="i !== patients.length-1"-->
                                {{ mapObe(ent, 'CLIENT') | getEntityName }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <table style="height: 100%">
                          <tr>
                            <td
                              [matTooltip]="'Status:' + (task.progress | getTaskStatus)"
                              class="border-{{ task.progress }}"
                            ></td>
                            <td>
                              <p style="padding-left: 4px; margin-bottom: 0; width: 90px">
                                {{ task.progress | getTaskStatus }}
                              </p>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="width: 30px" class="d-flex flex-center h-100">
                        <img
                          *ngIf="task.blockers?.length"
                          [matTooltip]="getBlockersString(task.blockers)"
                          src="./assets/media/svg/icons/General/blocker.svg"
                          alt="Blocker Icon"
                          width="24px"
                        />
                      </td>
                      <td class="border-grid-right">
                        <div
                          class="symbol symbol-20 mr-2 ml-2 cursor-pointer"
                          matTooltip="Comments"
                        >
                          <div class="symbol-label" style="background-color: white">
                            <i
                              (click)="showComments($event, task)"
                              class="flaticon2-chat-1 icon-lg"
                            ></i>
                          </div>
                          <i class="symbol-badge bg-danger" *ngIf="task.has_comment"></i>
                        </div>
                        <div class="symbol symbol-20 mr-2 ml-2" matTooltip="Attachments">
                          <div class="symbol-label" style="background-color: white">
                            <i class="flaticon-attachment icon-lg"></i>
                          </div>
                          <i
                            class="symbol-badge bg-danger"
                            *ngIf="task.task_attachments && task.task_attachments.length > 0"
                          ></i>
                        </div>

                        <div class="symbol symbol-20 mr-2 ml-2" matTooltip="Tags">
                          <div class="symbol-label" style="background-color: white">
                            <i class="flaticon2-tag icon-lg"></i>
                          </div>
                          <i class="symbol-badge bg-danger" *ngIf="task.task_tags?.length > 0"></i>
                        </div>
                        <div class="symbol symbol-20 mr-2 ml-2" matTooltip="Follow-up">
                          <div class="symbol-label" style="background-color: white">
                            <i
                              (click)="openFollowUpDialog(task); $event.stopPropagation()"
                              class="flaticon-calendar-with-a-clock-time-tools icon-lg"
                            ></i>
                          </div>
                          <i class="symbol-badge bg-danger" *ngIf="task.has_followup"></i>
                        </div>
                      </td>
                      <td style="padding-left: 10px; padding-right: 4px">
                        <div class="symbol" *ngIf="!isCompleted && !isCanceled && task.due_date">
                          <div
                            class="label label-lg label-light-{{
                              checkDateRectangleStyle(task.due_date)
                            }} label-inline text-dark"
                            style="color: black; width: 100px; font-size: 0.8rem"
                          >
                            <span *ngIf="checkDateRectangle(task.due_date)" class="pr-1">{{
                              checkDateRectangle(task.due_date) + ' |'
                            }}</span>
                            <span
                              *ngIf="
                                checkDateRectangle(task.due_date) === 'TD' ||
                                checkDateRectangle(task.due_date) === 'TM'
                              "
                              class="pl-1"
                              >{{ task.due_date + ' UTC' | date : 'h:mm a' }}</span
                            >
                            <span
                              *ngIf="
                                checkDateRectangle(task.due_date) !== 'TD' &&
                                checkDateRectangle(task.due_date) !== 'TM' &&
                                checkDateRectangle(task.due_date) !== null
                              "
                              class="pl-1"
                              >{{ task.due_date + ' UTC' | date : 'MM/dd' }}</span
                            >
                            <span
                              *ngIf="
                                checkDateRectangle(task.due_date) !== 'TD' &&
                                checkDateRectangle(task.due_date) !== 'TM' &&
                                checkDateRectangle(task.due_date) !== 'OD'
                              "
                              class="pl-1"
                              >{{ task.due_date + ' UTC' | date : 'MM/dd/yyyy' }}</span
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </mat-panel-description>
                <div style="width: 120px !important" class="symbol-group symbol-hover">
                  <div
                    *ngIf="usersObj.length > 0 && task.task_responsible_users.length > 0"
                    [matTooltip]="getFullNameList(task.task_responsible_users[0])"
                    matTooltipPosition="above"
                  >
                    <kt-user-photo
                      [create]="false"
                      [size]="26"
                      [type]="'object'"
                      [editable]="false"
                      [user$]="getUser(task.task_responsible_users[0])"
                    ></kt-user-photo>
                  </div>
                  <div
                    *ngIf="task.task_responsible_users.length > 1"
                    class="symbol symbol-25 symbol-circle symbol-light-primary"
                  >
                    <span
                      [matTooltip]="getNameList(task.task_responsible_users)"
                      matTooltipPosition="above"
                      class="symbol-label font-weight-bold"
                      >{{ task.task_responsible_users.length - 1 }}+</span
                    >
                  </div>
                </div>
              </div>
              <div class="lock-overlay" *ngIf="task.lock" (click)="unlockTask(task)">
                <div class="overlay-content" style="display: contents">
                  <div class="overlay-icon" style="padding-top: 3px">
                    <span class="material-icons md-24"> lock_open </span>
                  </div>
                  <div style="font-size: 15px !important; text-align: center">
                    Task locked by {{ task.locked_by }}, press to unlock
                  </div>
                </div>
              </div>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="xyloading" *ngIf="loading">Loading....</div>
        <div class="no-task" *ngIf="taskList.length === 0 && !loading" [ngStyle]="getStyleNoTask()">
          There are no tasks to show
        </div>
      </div>
      <!-- start: BOTTOM -->
      <div class="mat-table-bottom">
        <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
        <mat-spinner [diameter]="20" *ngIf="loading"></mat-spinner>
        <!-- MATERIAL PAGINATOR | Binded to dasources -->
        <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
        <mat-paginator
          [hidden]="inputTasks"
          [pageSize]="size"
          [pageSizeOptions]="[10, 25, 50, 200]"
          [length]="totalNumber"
          (page)="loadPage($event)"
          [showFirstLastButtons]="true"
        ></mat-paginator>
      </div>
      <!-- end: BOTTOM -->
    </div>
  </div>
</div>
